/* esm.sh - use-callback-ref@1.3.3 */
export * from "/*use-callback-ref@1.3.3/esnext/use-callback-ref.mjs";
